import { useChatRoom } from '@commenda/api/chatRoom/useChatRoom';
import { useServiceRequest } from '@commenda/api/service-request/useServiceRequest';
import { IChatRoomMessage } from '@commenda/types/src/chat-room/types';
import { WorkRequestResponseType } from '@commenda/types/src/work-request/types';
import { useEffect, useState } from 'react';

interface UseChatMessagesReturn {
  messages: IChatRoomMessage[];
  isLoading: boolean;
  error: string | null;
  chatRoomId: string | null;
}

export const useChatMessages = (
  workRequestData?: WorkRequestResponseType
): UseChatMessagesReturn => {
  const [messages, setMessages] = useState<IChatRoomMessage[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const serviceRequestId =
    workRequestData?.task?.taskGroup
      ?.serviceRequestId;

  const { data: serviceRequestData, error: serviceRequestError } =
    useServiceRequest(serviceRequestId || '');
  const { data: chatRoomData, error: chatRoomError } = useChatRoom({
    chatRoomId: serviceRequestData?.ChatRoom?.id ?? null,
  });

  useEffect(() => {
    if (chatRoomData?.chatRoom?.chatMessages) {
      // Return all chat messages (they will be filtered in the component if needed)
      setMessages(chatRoomData.chatRoom.chatMessages);
      setIsLoading(false);
    } else if (serviceRequestId && !chatRoomData && !chatRoomError) {
      setIsLoading(true);
    } else if (serviceRequestId && !chatRoomData && chatRoomError) {
      setError('Failed to load chat messages');
      setIsLoading(false);
    } else if (!serviceRequestId) {
      setIsLoading(false);
    }
  }, [chatRoomData, chatRoomError, serviceRequestId]);

  useEffect(() => {
    if (serviceRequestError) {
      setError('Failed to load chat messages');
      setIsLoading(false);
    }
  }, [serviceRequestError]);

  return {
    messages,
    isLoading,
    error,
    chatRoomId: serviceRequestData?.ChatRoom?.id || null,
  };
};

